module.exports = __webpack_public_path__ + "img/New PACI Flow AR - Enable Authentication - 3.a60760ee.png";